// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateShowNoResultsFound = hasNoResult => ({
    hasNoResult,
    type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
});



// WEBPACK FOOTER //
// ./src/reports/shared/action-creators/show-no-results-found.js